<template>
  <div class="loading-spinner">
    <div class="spinner-border mb-2" role="status"></div>
		<span>Loading...</span>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner"
};
</script>